'use client'

import { useHistoryStore } from '@stores/history.store'

import Image from 'next/image'

import cn from 'clsx'
import { useShallow } from 'zustand/react/shallow'

import backIcon from './back-icon.svg'

import styles from './back-link.module.scss'
import Link from 'next/link'

type BackLinkProps = {
  className?: string
  children?: string
  backToSearch?: boolean
  /**
   * Custom fallback url when the browser has no history.
   * If no specified the fallback is the homepage.
   */
  fallback?: string
}

const BackLink = ({ children = 'Back', className, backToSearch, fallback }: BackLinkProps): JSX.Element => {
  const [lastUrl, lastSearch, historyPop] = useHistoryStore(
    useShallow((state) => [state.lastUrl, state.lastSearch, state.pop]),
  )
  const classes = cn(styles.back, className)

  const link = (): string => {
    const url = lastUrl[lastUrl.length - 2]
    const search = lastSearch[lastSearch.length - 1]

    if (backToSearch) {
      return search ?? ''
    }

    if (fallback && url === '/') {
      return fallback
    }
    return url ?? ''
  }

  return (
    <Link
      href={link()}
      aria-label={children}
      className={classes}
      onClick={(): void => historyPop(backToSearch ? 'search' : 'urls')}
    >
      <span>
        <Image src={backIcon} alt="Left arrow icon" className={styles.icon} />
        {children}
      </span>
    </Link>
  )
}

export default BackLink
